import { render, staticRenderFns } from "./FavoritePopup.vue?vue&type=template&id=26d8737f&"
import script from "./FavoritePopup.vue?vue&type=script&lang=js&"
export * from "./FavoritePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports